import script from "./PdmiInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./PdmiInformation.vue?vue&type=script&setup=true&lang=js"

import "./PdmiInformation.vue?vue&type=style&index=0&id=23668996&scoped=true&lang=css"

import exportComponent from "E:\\gcm3\\AI Inventory\\codebase\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23668996"]])

export default __exports__